const PLAY_STORE_ID = 'me.solochat.chat';
const APP_STORE_ID = '';
const APP_STORE_URL = APP_STORE_ID ? `https://apps.apple.com/app/id${APP_STORE_ID}` : '#';
const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`;
const APP_SCHEME = 'solochat://';
const DEEP_LINK_BASE = 'https://solochat.me';

export function getPlatform() {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  return 'desktop';
}

export function getStoreUrl(platform) {
  if (platform === 'android') return PLAY_STORE_URL;
  if (platform === 'ios') return APP_STORE_URL;
  return '';
}

export function getPlayStoreUrl() {
  return PLAY_STORE_URL;
}

export function getAppStoreUrl() {
  return APP_STORE_URL;
}

export function getDeepLinkUrl(type, identifier) {
  switch (type) {
    case 'user': return `${DEEP_LINK_BASE}/u/${identifier}`;
    case 'group': return `${DEEP_LINK_BASE}/group/${identifier}`;
    case 'room': return `${DEEP_LINK_BASE}/room/${identifier}`;
    case 'chat': return `${DEEP_LINK_BASE}/chat/${identifier}`;
    default: return DEEP_LINK_BASE;
  }
}

export function getCustomSchemeUrl(type, identifier) {
  switch (type) {
    case 'user': return `${APP_SCHEME}u/${identifier}`;
    case 'group': return `${APP_SCHEME}group/${identifier}`;
    case 'room': return `${APP_SCHEME}room/${identifier}`;
    case 'chat': return `${APP_SCHEME}chat/${identifier}`;
    default: return APP_SCHEME;
  }
}

export function getAppLabel(type) {
  switch (type) {
    case 'user': return 'User Profile';
    case 'group': return 'Group';
    case 'room': return 'Room';
    case 'chat': return 'Chat';
    default: return 'Content';
  }
}

export function getContextMessage(type, identifier) {
  switch (type) {
    case 'user': return `View ${identifier}'s profile on SoloChat`;
    case 'group': return `Join this group on SoloChat`;
    case 'room': return `Enter this room on SoloChat`;
    case 'chat': return `Open this chat on SoloChat`;
    default: return `Open in SoloChat`;
  }
}

export function getPageTitle(type, identifier) {
  switch (type) {
    case 'user': return `${identifier} - SoloChat Profile`;
    case 'group': return `Group - SoloChat`;
    case 'room': return `Room - SoloChat`;
    case 'chat': return `Chat - SoloChat`;
    default: return `SoloChat`;
  }
}

export function getPageDescription(type, identifier) {
  switch (type) {
    case 'user': return `View ${identifier}'s profile on SoloChat. Connect and chat with ${identifier} on SoloChat.`;
    case 'group': return `Join this group conversation on SoloChat. Connect with people around you.`;
    case 'room': return `Enter this room on SoloChat and start chatting with others.`;
    case 'chat': return `Open this conversation on SoloChat.`;
    default: return `SoloChat - Connect with people around you.`;
  }
}

export function getAndroidIntentUrl(type, identifier) {
  const path = getDeepLinkUrl(type, identifier).replace(DEEP_LINK_BASE, '');
  const fallbackUrl = encodeURIComponent(getDeepLinkUrl(type, identifier));
  return `intent://${path.slice(1)}#Intent;scheme=https;package=${PLAY_STORE_ID};S.browser_fallback_url=${fallbackUrl};end`;
}

export function tryOpenApp(platform, type, identifier) {
  if (platform === 'android') {
    window.location.href = getAndroidIntentUrl(type, identifier);
  } else if (platform === 'ios') {
    window.location.href = getCustomSchemeUrl(type, identifier);
  }
}
